import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import CalendarModal from "./calendarModal";
import useFetch from "../../../hooks/useFetch";
import { CalendarDate } from "../../../types/dataModel";
import PreLoader from "../../../core/common/preLoader";
import { getAPIHeaders, getFormattedDateDDMMYYYY } from "../../../common/Utils";
import { API } from "../../../common/Constants";
import DeleteModal from "../../../core/modals/deleteModal";
import PredefinedDateRanges from "../../../core/common/datePicker";
import moment from "moment";
import CopyRightInfo from "../../../core/common/copyRightInfo";
import { useAccess } from "../../../hooks/accessContext";

const Calendar = () => {
    const { hasCalendarCreate, hasCalendarDelete, hasCalendarEdit } = useAccess()
    const routes = all_routes;
    const { isLoading, callFetch } = useFetch();
    const [calendarDates, setCalanderDates] = useState<CalendarDate[]>([])
    const [editId, setEditId] = useState<number>(0);
    const [viewType, setViewType] = useState<'table' | 'card'>('table');
    const [deleteItem, setDeleteItem] = useState<any>({
            id:undefined, 
            message: undefined,
    })
    const [dateRange, setDateRange] = useState<any>({
        start: moment().startOf('year').toDate().getTime(),
        end: moment().endOf('year').toDate().getTime(),
    })
    const [stats, setStats] = useState<any>()

    const columns = [
        {
          title: "Description",
          dataIndex: "description",
          render: (text: string, record: any) => (
            <div className="d-flex align-items-center">
              <div className="ms-2">
                <p className="text-dark mb-0">
                  <h6 className="fw-medium">
                    <Link 
                      to="#" 
                      className="text-reset text-decoration-none"
                      onClick={() => { setEditId(record?.id) }}
                      data-bs-toggle="modal"
                      data-bs-target="#edit_holiday"
                    >
                      {text}
                    </Link>
                  </h6>
                </p>
                <div className="d-flex align-items-center mt-1 calendar-info">
                  <span className="badge badge-soft-primary me-2 fs-12">
                    ID: {record.id}
                  </span>
                </div>
              </div>
            </div>
          ),
          sorter: (a: any, b: any) => a.Title?.length - b.Title?.length,
        },
        {
            title: "Start Date",
            dataIndex: "startTime",
            sorter: (a: any, b: any) => a.startTime - b.startTime,
            render: (text:string) => (
              <div className="d-flex align-items-center">
                <div className="ms-2">
                  <div className="d-flex align-items-center">
                    <span className="badge badge-soft-info me-2 fs-12">
                      {getFormattedDateDDMMYYYY(parseInt(text))}
                    </span>
                  </div>
                </div>
              </div>
            ),
            defaultSortOrder: 'ascend',
        },
        {
            title: "End Date",
            dataIndex: "endTime",
            sorter: (a: any, b: any) => a.endTime - b.endTime,
            render: (text:string) => (
              <div className="d-flex align-items-center">
                <div className="ms-2">
                  <div className="d-flex align-items-center">
                    <span className="badge badge-soft-info me-2 fs-12">
                      {getFormattedDateDDMMYYYY(parseInt(text))}
                    </span>
                  </div>
                </div>
              </div>
            ),
        },
        {
            title: "Type",
            dataIndex: "type",
            render: (text: string) => (
              text === 'PUBLIC_HOLIDAY' ?
                <span className="badge badge-success d-inline-flex align-items-center badge-sm">  
                    Public Holiday
                </span>
                :
                text === 'HOLIDAY' ?
                <span className="badge badge-danger d-inline-flex align-items-center badge-sm">  
                    Holiday
                </span>
                :
                text === 'EVENT' ?
                <span className="badge badge-warning d-inline-flex align-items-center badge-sm">
                  Event
                </span>
                :
                <></>
              ),
            sorter: (a: any, b: any) => a.Status.length - b.Status.length,
        },
        {
            title: "",
            dataIndex: "actions",
            render: (text: string, record:any) => (
                <div className="action-icon d-inline-flex">
                    <Link
                        hidden={!hasCalendarEdit()}
                        to="#"
                        className="me-2 icon-edit"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#edit_holiday"
                        onClick={()=>{
                          setEditId(record?.id)
                        }}
                        title="Edit Event"
                    >
                        <i className="ti ti-edit" />
                    </Link>
                    <Link
                        hidden={!hasCalendarDelete()}
                        to="#"
                        className="icon-delete"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#delete_modal"
                        onClick={()=>setDeleteItem({
                          id: record.id,
                          message: `Are you sure you want to delete ${record.description}? This can't be undone.`
                        })}
                        title="Delete Event"
                    >
                        <i className="ti ti-trash" />
                    </Link>
                </div>
            ),
        },
    ];

    useEffect(() => {
      fetchCalander()
    }, [dateRange]);


    const fetchCalander = () => {
      callFetch(`${API.CALENDAR}?fromDate=${dateRange.start}&toDate=${dateRange.end}`,
        'GET',
        getAPIHeaders(),
        null,
        null
      ).then((res)=>{
        setCalanderDates(res?.calendarEvents)
        setStats(res?.calendarStatsCard)
      }).catch(()=>{});
    }

    const deleteCalanderDate = (id:number) => {
      callFetch(`${API.CALENDAR}/${id}`,
        'DELETE',
        getAPIHeaders(),
        null,
        null
      ).then((res)=>{
        fetchCalander()
      }).catch((err)=>{});
    }

    const renderStatCards = () => {
      return (          
      <div className="row">
        <div className="col-xl-3 col-md-6">
            <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center overflow-hidden mb-2">
                  <div className="attendence-icon">
                    <span><i className="ti ti-calendar text-danger"></i></span>
                  </div>
                  <div className="ms-2 overflow-hidden">
                    <p className="fs-12 fw-normal mb-1 text-truncate">Total Org Events</p>
                    <h4>{stats?.totalOrgEvents}</h4>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center overflow-hidden mb-2">
                  <div className="attendence-icon">
                    <span><i className="ti ti-calendar text-warning"></i></span>
                  </div>
                  <div className="ms-2 overflow-hidden">
                    <p className="fs-12 fw-normal mb-1 text-truncate">Upcoming Org Events</p>
                    <h4>{stats?.upcomingOrgEvents}</h4>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center overflow-hidden mb-2">
                  <div className="attendence-icon">
                    <span><i className="ti ti-calendar text-info"></i></span>
                  </div>
                  <div className="ms-2 overflow-hidden">
                    <p className="fs-12 fw-normal mb-1 text-truncate">Total Holidays</p>
                    <h4>{stats?.totalHolidays}</h4>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="card flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center overflow-hidden mb-2">
                  <div className="attendence-icon">
                    <span><i className="ti ti-calendar text-success"></i></span>
                  </div>
                  <div className="ms-2 overflow-hidden">
                    <p className="fs-12 fw-normal mb-1 text-truncate">Holidays This Month</p>
                    <h4>{stats?.holidaysThisMonth}</h4>
                  </div>
                </div>
              </div>
          </div>
        </div>      
      </div>)
    }

    return (
      <>
        <PreLoader showLoader={isLoading} />
        <DeleteModal 
              heading="Confirm Delete"
              message={deleteItem.message}
              onDelete={()=>deleteCalanderDate(deleteItem?.id)}
            />
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Calendar</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.holidays}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Calendar</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Calendar List
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="mb-2">
                  <button
                    disabled={!hasCalendarCreate()}
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#edit_holiday"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Entry
                  </button>
                </div>
                <div className="head-icons ms-2">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            {renderStatCards()}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Event List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="view-toggle me-3">
                    <button 
                      className={`btn btn-sm me-2 ${viewType === 'table' ? 'btn-primary' : 'btn-outline-primary'}`} 
                      onClick={() => setViewType('table')}
                      aria-label="Switch to table view"
                    >
                      <i className="ti ti-table me-1"></i> Table View
                    </button>
                    <button 
                      className={`btn btn-sm ${viewType === 'card' ? 'btn-primary' : 'btn-outline-primary'}`} 
                      onClick={() => setViewType('card')}
                      aria-label="Switch to card view"
                    >
                      <i className="ti ti-layout-grid me-1"></i> Card View
                    </button>
                  </div>
                  <div className="me-3">
                    <div className="input-icon-end position-relative">
                      <PredefinedDateRanges 
                      onChange={(start: moment.Moment, end: moment.Moment)=>{
                        setDateRange({
                          start: start?.toDate().getTime(),
                          end: end?.toDate().getTime()
                        })
                      }}
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-chevron-down" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                {viewType === 'table' ? (
                  <Table dataSource={calendarDates} columns={columns} Selection={false} refresh={fetchCalander} />
                ) : (
                  <div className="calendar-cards p-3">
                    <div className="row">
                      {calendarDates?.map((event: any) => (
                        <div className="col-xl-4 col-lg-6 col-md-6 mb-3" key={event.id}>
                          <div className="card h-100 border shadow-sm">
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="d-flex align-items-center">
                                  <div className={`avatar avatar-sm me-3 flex-shrink-0 rounded-circle 
                                    ${event.type === 'PUBLIC_HOLIDAY' ? 'bg-light-success' : 
                                      event.type === 'HOLIDAY' ? 'bg-light-danger' : 'bg-light-warning'}`}>
                                    <span className={`
                                      ${event.type === 'PUBLIC_HOLIDAY' ? 'text-success' : 
                                        event.type === 'HOLIDAY' ? 'text-danger' : 'text-warning'} fw-bold`}>
                                      <i className="ti ti-calendar"></i>
                                    </span>
                                  </div>
                                  <h6 className="mb-0 fw-semibold event-title">
                                    {event.description}
                                  </h6>
                                </div>
                                {event.type === 'PUBLIC_HOLIDAY' ? (
                                  <span className="badge badge-soft-success">Public Holiday</span>
                                ) : event.type === 'HOLIDAY' ? (
                                  <span className="badge badge-soft-danger">Holiday</span>
                                ) : (
                                  <span className="badge badge-soft-warning">Event</span>
                                )}
                              </div>
                              
                              <div className="event-dates mb-3">
                                <div className="row">
                                  <div className="col-6">
                                    <div className="fs-12 fw-medium text-dark">Start Date</div>
                                    <div className="fs-12">{getFormattedDateDDMMYYYY(parseInt(event.startTime))}</div>
                                  </div>
                                  <div className="col-6">
                                    <div className="fs-12 fw-medium text-dark">End Date</div>
                                    <div className="fs-12">{getFormattedDateDDMMYYYY(parseInt(event.endTime))}</div>
                                  </div>
                                </div>
                              </div>
                              
                              <div className="d-flex justify-content-end mt-3">
                                <Link
                                  hidden={!hasCalendarEdit()}
                                  to="#"
                                  className="btn btn-sm btn-outline-primary me-2"
                                  data-bs-toggle="modal" data-inert={true}
                                  data-bs-target="#edit_holiday"
                                  onClick={() => { setEditId(event.id) }}
                                  title="Edit Event"
                                >
                                  <i className="ti ti-edit me-1" /> Edit
                                </Link>
                                <Link
                                  hidden={!hasCalendarDelete()}
                                  to="#"
                                  className="btn btn-sm btn-outline-danger"
                                  data-bs-toggle="modal" data-inert={true}
                                  data-bs-target="#delete_modal"
                                  onClick={() => setDeleteItem({
                                    id: event.id,
                                    message: `Are you sure you want to delete ${event.description}? This can't be undone.`,
                                  })}
                                  title="Delete Event"
                                >
                                  <i className="ti ti-trash me-1" /> Delete
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
            <CopyRightInfo/>
          </div>
        </div>
        {/* /Page Wrapper */}

        <CalendarModal 
          onSuccess={fetchCalander} 
          calendarDate={calendarDates?.find((el:any)=> el.id === editId)}
          onClose={()=>{
            setEditId(0);
          }}
        />
      </>
    );
};

export default Calendar;